import config from "@Config/index";
import axios from "axios";

const fetchBudgetFriendly = async ({
  id,
  userCurrency,
  selectedLang,
}: {
  id: any;
  userCurrency?: string;
  selectedLang?: string;
}) => {
  const params: any = {
    limit: 10,
    use_open_search: true,
    only: "id,name,canonical_name,location,available,pricing,region_id,images,status,reviews_count,reviews_rating",
    type: "empty",
    methods: "meta_short,images_with_featured,reviews_count,reviews_rating",
    lang: selectedLang || "en",
  };
  if (userCurrency) {
    params.user_currency = userCurrency;
  }

  return axios.get(`${config.API_URL}/api/v0/inventories/${id}/budget_friendly`, { params });
};

export default fetchBudgetFriendly;
